import React from 'react';
import JobBasicInfoComponent from './job-basic-info.component';
import MobileMediaInfoComponent from '../../../../../../common/components/common/mobile-media.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';


export const JobComponent = ({ mediaFiles, handleFormMediaItemChange, fileTypes, changeImage, colorDecider, shippingStatusId, handleRejectOpen, handleMenuClose, handleShipmentStatusClick, back, jobDetails, getShippingType, getTransporterAgentName, setAnchorShipmentEl, ConvertMinutes, anchorShipmentEl }: any) => {
    const tabItems = [
        {
            id: 1,
            title: 'Basic Info',
            component: <JobBasicInfoComponent
                colorDecider={colorDecider}
                shippingStatusId={shippingStatusId}
                handleRejectOpen={handleRejectOpen}
                handleMenuClose={handleMenuClose}
                handleShipmentStatusClick={handleShipmentStatusClick}
                jobDetails={jobDetails}
                getShippingType={getShippingType}
                getTransporterAgentName={getTransporterAgentName}
                setAnchorShipmentEl={setAnchorShipmentEl}
                ConvertMinutes={ConvertMinutes}
                anchorShipmentEl={anchorShipmentEl} />,
            isVisible: true,
        },

        {
            id: 2,
            title: 'E-Way Bill Info',
            component:
                <MobileMediaInfoComponent
                    changeImage={changeImage}
                    fileTypes={fileTypes}
                    onFormItemChange={handleFormMediaItemChange}
                    mediaFiles={mediaFiles}
                />,
            isVisible: true
        }

    ]
    return (
        <>
            <div className="fixed top-20 left-0 w-full flex items-center justify-start py-3 px-4 border-b border-gray-300 bg-white shadow-md z-50">
                <button
                    onClick={back}
                    className="flex items-center gap-2 text-gray-800 font-medium hover:text-blue-700 transition-all duration-300"
                    aria-label="Go Back"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" fill="none">
                        <path d="M3.99982 11.9998L19.9998 11.9998" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M8.99963 17C8.99963 17 3.99968 13.3176 3.99966 12C3.99965 10.6824 8.99966 7 8.99966 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span>Jobs</span>
                </button>
            </div>

            <div className="flex flex-col items-center w-full min-h-screen overflow-auto p-4 bg-gray-50 pt-16 mb-20">
                <TabContainer tabItems={tabItems} />
            </div>
        </>
    )
}
export default JobComponent;